import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { fetchCoordinatorRequest } from '../../app/PartnerSearch/actions';
import { IState } from '../../reducers';
import { OrganizationData } from './OrganizationData';
import { PublicProjectsData } from './PublicProjectsData';
import { NetContributionData } from './NetContributionData';
import { CoordinatorData } from './CoordinatorsData';
import { CollaborationNetworkGraph } from './CollaborationNetworkGraph';
import './OrganizationProfilePage.css';
import { ICoordinatorSearchState } from '../../app/PartnerSearch/reducer';
// import PartnerSearchAnouncement from './PartnerSearchAnouncement';

interface IRouteParams {
  id: string;
}

interface IOrganizationPageProps extends RouteComponentProps<IRouteParams> {
  coordinatorData: ICoordinatorSearchState;
  dispatch: any;
}

const OrganizationPage: React.FC<IOrganizationPageProps> = ({ coordinatorData, dispatch, match }) => {
  const { selectedPartner } = coordinatorData;

  React.useEffect(() => {
    const { id } = match.params;
    dispatch(fetchCoordinatorRequest(Number(id)));
  }, [dispatch, match.params]);

  const orgData = React.useMemo(
    () => ({
      type: selectedPartner?.activityType,
      name: selectedPartner?.name,
      description: selectedPartner?.orgDetailes?.description,
      keywords: selectedPartner?.orgDetailes?.keywords,
      organizationUrl: selectedPartner?.organizationUrl,
      location: {
        street: selectedPartner?.street,
        city: selectedPartner?.city,
        country: selectedPartner?.country,
        postCode: selectedPartner?.postCode,
      },
      vatNumber: selectedPartner?.vatNumber,
      picId: selectedPartner?.id,
    }),
    [selectedPartner],
  );

  if (!selectedPartner || Object.keys(selectedPartner).length === 0) {
    return <div>Loading....</div>;
  }

  return (
    <div className="organization-profile-page">
      <OrganizationData orgData={orgData} />
      <div className="col">
        <NetContributionData netContribution={selectedPartner?.ecContribution || ''} />
      </div>
      <div className="col">
        <PublicProjectsData projects={selectedPartner?.orgDetailes?.publicProjects || []} />
      </div>
      <div className="col">
        <CoordinatorData coordinators={selectedPartner?.orgDetailes?.collaborations} />
      </div>
      <div className="col">
        <CollaborationNetworkGraph
          collaborations={selectedPartner?.orgDetailes?.collaborations || []}
          centerPartner={{
            id: selectedPartner?.id || '',
            name: selectedPartner?.name || '',
            activityType: selectedPartner?.activityType || ''
          }}
        />
      </div>
      {/* <div className='col'>
                <PartnerSearchAnouncement topicsWithOrganizationInterest={selectedPartner?.orgDetailes?.topicsWithOrganizationInterest} />
            </div> */}
    </div>
  );
};

const mapStateToProps = ({ coordinatorData }: IState) => {
  return { coordinatorData };
};

export const OrganizationProfilePage = connect(mapStateToProps)(OrganizationPage);
